import { Box, Typography } from '@mui/material'
import { parseISO } from 'date-fns'
import PropTypes from 'prop-types'
import TextTruncate from 'react-text-truncate'

import { defaultTimeZoneFormat } from '@hapana/shared/utils/date.util'
import { useSiteConfiguration } from '@hapana/shared/web/hooks/siteConfiguration.hooks'

import { styles } from './notes-properties.styles'

const NoteAlert = ({ description, date }) => {
  const { data } = useSiteConfiguration()
  return (
    <Box sx={styles.notesContainer}>
      <Box>
        <Typography
          typography="medium"
          color="gray.80"
          //TODO: Will keep this functionality if needed in future
          // dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.description) }}
        >
          <TextTruncate
            line={2}
            element="span"
            truncateText=""
            text={description}
            textTruncateChild="..."
          />
        </Typography>
        <Typography typography="small" color="gray.64" sx={styles.date}>
          {defaultTimeZoneFormat(parseISO(date), data?.timezone)}
        </Typography>
      </Box>
    </Box>
  )
}

export default NoteAlert

NoteAlert.propTypes = {
  description: PropTypes.string,
  date: PropTypes.string,
}

NoteAlert.defaultProps = {
  property: '',
  description: '',
}
